import {ReactElement, useMemo, useState} from 'react';

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import {Box, Menu, useTheme} from '@mui/material';

import {EmpionButton} from '../EmpionButton/EmpionButton';
import {EmpionTooltip} from '../EmpionTooltip/EmpionTooltip';

import {
  getHeaderMenuListSx,
  getHeaderMenuTriggerSx,
  getMenuStyles,
} from '../../layouts/theme/ThemeHelpers';

interface Props {
  buttonLabel: string;
  isDisabled?: boolean;
  disabledHoverText?: string;
  children: ReactElement | ReactElement[];
}

export const DropdownMenu = ({buttonLabel, isDisabled, children, disabledHoverText}: Props) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const menuStyles = useMemo(() => getMenuStyles(theme, {variant: 'header-module'}), [theme]);
  const menuListSx = useMemo(() => getHeaderMenuListSx('header-module'), []);
  const triggerSx = useMemo(() => getHeaderMenuTriggerSx(open, theme), [open, theme]);

  return (
    <Box>
      <EmpionTooltip title={disabledHoverText || ''} isEnabled={isDisabled}>
        <EmpionButton
          variant='menu'
          disableElevation
          disabled={isDisabled}
          onClick={handleClick}
          endIcon={<ArrowDropDownIcon />}
          sx={{
            ...triggerSx,
            '& .MuiButton-endIcon': {
              transition: 'transform 0.2s',
              transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
            },
          }}
        >
          {buttonLabel}
        </EmpionButton>
      </EmpionTooltip>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClick={handleClose}
        onClose={handleClose}
        sx={menuStyles}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        MenuListProps={menuListSx ? {sx: menuListSx} : undefined}
      >
        {children}
      </Menu>
    </Box>
  );
};
